module.exports = __webpack_public_path__ + "static/media/Revert_Icon.f1409e3d.svg";